import moment from 'moment';

export const getAge = (birth_date: any) => {
  const birthDate = moment(birth_date);
  const currentDate = moment();
  const age = moment(currentDate).diff(birthDate, 'years');
  return age;
};
